
import {defineComponent} from "vue";
import RatingForm from "./RatingForm.vue";
import RatingList from "./RatingList.vue";

export default defineComponent({
  name: "ContentRating",
  components: { RatingList, RatingForm }
});
